/* np-home.js — behaviour for sections/new-home.liquid.
   Reads its per-page config from <script type="application/json" id="nh-config">.
   Cart adds go through the shared window.npCart API (assets/np-chrome.js). */
(function () {
  "use strict";
  var $ = function (id) { return document.getElementById(id); };
  var money = function (n) { return "£" + n.toFixed(2); };

  var configEl = $("nh-config");
  var CONFIG = {};
  if (configEl) {
    try { CONFIG = JSON.parse(configEl.textContent) || {}; } catch (e) { CONFIG = {}; }
  }

  /* Lipscore is the store's review platform; hydrate rating widgets.
     The theme's app embed usually loads it — this is a fallback. */
  if (!document.querySelector('script[src*="lipscore"]')) {
    window.lipscoreInit = function () { window.lipscore.init({ apiKey: "54b15725d0301f12251693f6" }); };
    var lsc = document.createElement("script");
    lsc.async = true;
    lsc.src = "https://static.lipscore.com/assets/en/lipscore-v1.js";
    document.head.appendChild(lsc);
  }

  /* ---- hero video: skip on small screens / reduced motion; load after first paint ---- */
  var HERO_VIDEO_URL = "https://efectivnutrition.com/cdn/shop/videos/c/vp/c0315c3bcd1343babcd050bec9a2f7c4/c0315c3bcd1343babcd050bec9a2f7c4.HD-1080p-4.8Mbps-87474385.mp4?v=0";
  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  }
  function loadHeroVideo() {
    var vid = $("nh-hero-video");
    if (!vid || window.innerWidth < 720 || prefersReducedMotion()) return;
    vid.addEventListener("loadeddata", function () {
      vid.style.display = "block";
      vid.play().catch(function () {});
    });
    vid.src = HERO_VIDEO_URL;
    document.addEventListener("visibilitychange", function () {
      if (!document.hidden && vid.paused && vid.src) vid.play().catch(function () {});
    });
  }
  function startAfterFirstPaint() {
    if (window.requestIdleCallback) window.requestIdleCallback(loadHeroVideo, { timeout: 2000 });
    else setTimeout(loadHeroVideo, 200);
  }
  if (document.readyState === "complete") startAfterFirstPaint();
  else window.addEventListener("load", startAfterFirstPaint);

  /* ---- dispatch line: the 4pm UK cut-off on working days (window.npDispatch, np-chrome.js),
     counting down until the cut-off; after it, the next dispatch day ---- */
  (function () {
    var el = $("nh-delivery");
    if (!el) return;
    if (!window.npDispatch) { el.textContent = "Order before 4pm for same-day dispatch"; return; }
    function paint() {
      var d = window.npDispatch();
      if (d.sameDay) {
        var h = Math.floor(d.minsLeft / 60), m = d.minsLeft % 60;
        el.textContent = "Order within " + (h ? h + "h " : "") + m + "m for same-day dispatch";
      } else {
        el.textContent = "Order now, dispatched " + d.label;
      }
    }
    paint();
    setInterval(paint, 30000);
  })();

  /* ---- sticky bar: shows once bestsellers is passed; cart-aware ----
     The count is the header's: np-chrome.js itemCount (npCart.itemCount), where a pack is one item and its
     component lines are not extra items (12 Oct 2026). Raw item_count counts every line, so it is only the
     fallback when np-chrome.js is missing. The first value comes from the cart the slide cart was seeded with. */
  function countOf(cart) {
    return window.npCart && window.npCart.itemCount ? window.npCart.itemCount(cart) : cart.item_count;
  }
  var seedCart = window.npCart && window.npCart.cart ? window.npCart.cart() : null;
  var cartCount = seedCart ? countOf(seedCart) : ((CONFIG.cart && CONFIG.cart.itemCount) || 0);
  var cartTotal = seedCart ? seedCart.total_price : ((CONFIG.cart && CONFIG.cart.totalPrice) || 0);
  document.documentElement.addEventListener("np:cart", function (e) {
    var c = e.detail && e.detail.cart;
    if (c) { cartCount = countOf(c); cartTotal = c.total_price; stickyText(); }
  });
  function stickyText() {
    if (!$("nh-sticky-title")) return;
    if (cartCount > 0) {
      $("nh-sticky-title").textContent = cartCount + " item" + (cartCount === 1 ? "" : "s") + " in your cart";
      $("nh-sticky-sub").textContent = "Subtotal " + money(cartTotal / 100) + " · 14-day returns";
      $("nh-sticky-cta").textContent = "Checkout";
    } else {
      $("nh-sticky-title").textContent = "Free UK delivery over £30";
      $("nh-sticky-sub").textContent = "14-day returns · dose on the label · made in the UK";
      $("nh-sticky-cta").textContent = "Shop bestsellers";
    }
  }
  stickyText();
  if ($("nh-sticky-cta")) {
    $("nh-sticky-cta").addEventListener("click", function () {
      if (cartCount > 0) {
        if (window.npSlideCart) window.npSlideCart.open();
        else window.location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || "/") + "cart";
        return;
      }
      var el = $("bestsellers");
      if (el) window.scrollTo({ top: el.offsetTop - 80, behavior: "smooth" });
    });
  }
  var bestsellersEl = $("bestsellers");
  var stickyEl = $("nh-sticky");
  if (bestsellersEl && stickyEl && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var passed = entry.boundingClientRect.bottom < 0;
      stickyEl.style.display = passed ? "block" : "none";
    }, { threshold: 0 });
    io.observe(bestsellersEl);
  }

  /* ---- bundle: pick three or more, choose each flavour, add to the cart with the tier code
     the way the Bundle Builder does (np-bundle-page.js). "Full bundle builder" carries the picks
     and flavours over as ?picks=handle:variant,... ---- */
  function bundleTier(n) {
    if (n >= 5) return { pct: 0.20, code: "BUNDLE20", id: "pro" };
    if (n === 4) return { pct: 0.16, code: "BUNDLE16", id: "athlete" };
    if (n === 3) return { pct: 0.12, code: "BUNDLE12", id: "starter" };
    return { pct: 0, code: null, id: null };
  }
  var picks = [];
  var pickCards = [].slice.call(document.querySelectorAll("[data-bpick]"));
  var bundleCta = $("nh-bcta");
  var bundleFull = $("nh-bfull");
  /* funnel events, as np-bundle-page.js (np-chrome.js npTrack), marked source: home */
  var bTracked = {};
  function bTrack(name, data) { if (window.npTrack) window.npTrack(name, data); }
  function bundleRender() {
    if (!bundleCta) return;
    if (picks.length > 0 && !bTracked.start) { bTracked.start = 1; bTrack("bundle_started", { source: "home" }); }
    [3, 4, 5].forEach(function (k) {
      var tk = bundleTier(k);
      if (picks.length >= k && !bTracked[tk.id]) { bTracked[tk.id] = 1; bTrack("bundle_tier_" + Math.round(tk.pct * 100), { source: "home", items: picks.length }); }
    });
    pickCards.forEach(function (card) {
      var on = picks.indexOf(card) > -1;
      card.classList.toggle("is-on", on);
      card.querySelector("[data-bmark]").textContent = on ? "✓" : "+";
      card.querySelector("button").setAttribute("aria-pressed", on ? "true" : "false");
    });
    var t = bundleTier(picks.length);
    var pence = picks.map(function (c) { return parseInt(c.dataset.bprice, 10); });
    var sum = pence.reduce(function (a, p) { return a + p; }, 0) / 100;
    /* Shopify floors a percentage code per unit, so match checkout exactly */
    var off = pence.reduce(function (a, p) { return a + Math.floor(p * t.pct + 1e-9); }, 0) / 100;
    $("nh-bcount").textContent = picks.length + " picked" + (t.pct ? " · " + Math.round(t.pct * 100) + "% tier" : "");
    $("nh-btotal").textContent = money(sum - off);
    $("nh-bwas").textContent = money(sum);
    $("nh-bwas").style.opacity = t.pct ? 1 : 0;
    $("nh-bsaving").textContent = t.pct
      ? "You save " + money(off) + (picks.length < 5 ? " · add more for a bigger tier" : " · top tier")
      : "Three products save 12%";
    bundleCta.disabled = !t.pct;
    bundleCta.textContent = t.pct ? "Add bundle to cart · " + money(sum - off) : "Choose 3 products";
    if (bundleFull) {
      var base = bundleFull.getAttribute("data-base");
      var list = picks.map(function (c) { return c.dataset.bhandle + ":" + c.dataset.bvid; }).join(",");
      bundleFull.href = base + (list ? (base.indexOf("?") > -1 ? "&" : "?") + "picks=" + encodeURIComponent(list) : "") + "#builder";
    }
  }
  pickCards.forEach(function (card) {
    card.querySelector("button").addEventListener("click", function () {
      var i = picks.indexOf(card);
      if (i > -1) picks.splice(i, 1); else picks.push(card);
      bundleRender();
    });
    var sel = card.querySelector("[data-bflavour]");
    if (sel) {
      sel.addEventListener("change", function () {
        var opt = sel.options[sel.selectedIndex];
        card.dataset.bvid = sel.value;
        card.dataset.bprice = opt.getAttribute("data-vprice");
        card.querySelector("[data-bflavname]").textContent = opt.text;
        card.querySelector(".hm-bpick-price").textContent = opt.getAttribute("data-vmoney");
        bundleRender();
      });
    }
  });
  if (bundleCta) {
    bundleCta.addEventListener("click", function () {
      var t = bundleTier(picks.length);
      if (!t.pct || !window.npCart) return;
      var bundleId = t.id + "-" + Date.now();
      var items = picks.map(function (c) {
        return { id: parseInt(c.dataset.bvid, 10), quantity: 1, properties: { _bundle_id: bundleId, _bundle_tier: t.id } };
      });
      var pence = picks.map(function (c) { return parseInt(c.dataset.bprice, 10); });
      var value = pence.reduce(function (a, p) { return a + p - Math.floor(p * t.pct + 1e-9); }, 0) / 100;
      var n = picks.length;
      /* npCart announces failures in its toast; the slide cart opens on success */
      window.npCart.add(items, { button: bundleCta, discount: t.code }).then(function () {
        bTrack("bundle_added_to_cart", { source: "home", tier: Math.round(t.pct * 100), items: n, value: value, currency: "GBP" });
        picks = [];
        bundleRender();
      }).catch(bundleRender);
    });
  }
  bundleRender();

  /* ---- quiz (design flow; stacks resolve to real variants) ---- */
  var QUIZ = [
    { q: "What are you training for?", a: ["Strength & size", "Endurance events", "Mixed / hybrid"] },
    { q: "How many sessions a week?", a: ["1–3", "4–5", "6+"] },
    { q: "What lets you down first?", a: ["Recovery", "Energy", "Hydration"] }
  ];
  var RESULTS = (CONFIG.quiz || {});
  var qStep = 0, qPick = null;
  function renderQuiz() {
    if (qStep >= 3) {
      $("nh-quiz-live").style.display = "none";
      $("nh-quiz-done").style.display = "block";
      var r = RESULTS[qPick] || RESULTS["Mixed / hybrid"] || { stack: "", why: "", items: [], total: 0 };
      var items = (r.items || []).filter(function (it) { return it && it.id; });
      $("nh-quiz-stack").textContent = r.stack;
      $("nh-quiz-why").textContent = r.why;
      var addBtn = $("nh-quiz-add");
      if (items.length) {
        addBtn.textContent = "Add stack · " + money(r.total / 100);
        addBtn.disabled = false;
      } else {
        addBtn.textContent = "Currently unavailable";
        addBtn.disabled = true;
      }
      return;
    }
    $("nh-quiz-live").style.display = "grid";
    $("nh-quiz-done").style.display = "none";
    $("nh-quiz-steplabel").textContent = "Question " + (qStep + 1) + " of 3";
    var pct = Math.round((qStep / 3) * 100);
    $("nh-quiz-pct").textContent = pct + "%";
    $("nh-quiz-bar").style.transform = "translateX(" + (pct - 100) + "%)";
    $("nh-quiz-q").textContent = QUIZ[qStep].q;
    var wrap = $("nh-quiz-answers");
    wrap.innerHTML = "";
    QUIZ[qStep].a.forEach(function (label) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "nh-quizbtn";
      b.style.cssText = "width:100%;display:flex;align-items:center;justify-content:space-between;gap:18px;border:0;background:#0B0B0B;padding:19px 22px;font:700 15px/1.3 Inter,system-ui,sans-serif;color:#fff;cursor:pointer;text-align:left;transition:background .15s ease,color .15s ease";
      var textSpan = document.createElement("span");
      textSpan.style.minWidth = "0";
      textSpan.textContent = label;
      var arrowSpan = document.createElement("span");
      arrowSpan.style.cssText = "width:7px;height:7px;border-top:1.8px solid currentColor;border-right:1.8px solid currentColor;transform:rotate(45deg);display:block;flex:none";
      b.appendChild(textSpan);
      b.appendChild(arrowSpan);
      b.addEventListener("click", function () {
        if (qStep === 0) qPick = label;
        qStep += 1;
        renderQuiz();
      });
      wrap.appendChild(b);
    });
  }
  if ($("nh-quiz-reset")) $("nh-quiz-reset").addEventListener("click", function () { qStep = 0; qPick = null; renderQuiz(); });
  if ($("nh-quiz-add")) {
    $("nh-quiz-add").addEventListener("click", function () {
      var r = RESULTS[qPick] || RESULTS["Mixed / hybrid"] || { items: [] };
      var items = (r.items || []).filter(function (it) { return it && it.id; });
      if (!items.length) return;
      var btn = $("nh-quiz-add");
      /* npCart announces failures in its toast; nothing else to do here */
      if (window.npCart) window.npCart.add(items, { button: btn }).catch(function () {});
    });
  }
  renderQuiz();
})();
